import React from "react";
import { shallowEqual } from "react-redux";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../redux/store";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import BasketItems from "./items/BasketItems";
import BasketETA from "./summary/BasketETA";
import PaymentDetails from "../PaymentDetails";
import * as Styles from "../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/Basket";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import * as Message from "../../../../../../../common-deprecated/styles/v2/toyota/components/Message";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon, { IconCart } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { useBnbOptionalLabel } from "../../../../utils/labels";
import BasketMassManagement from "./content/BasketMassManagement";
import ExternalPriceTaxDisclaimer from "../price/ExternalPriceTaxDisclaimer";
import BasketHeader from "./content/BasketHeader";
import BasketServices from "./content/BasketServices";
import { showModal } from "../../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_CONTENT } from "../../../../../../../common-deprecated/utils/modalConstants";
import TotalPriceDisclaimers from "../price/TotalPriceDisclaimers";
import TradeInDetails from "./content/TradeInDetails";
import { enabledServicesSelector } from "../../../../utils/selectorUtils";
import InsuranceDetails from "./content/InsuranceDetails";
import { showPrice } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";

import { isOnlinePurchaseAvailable } from "../../../../../../shared-logic/utils/basketUtils";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

type PropsType = {
    attached?: boolean;
};

const Basket = (props: PropsType): JSX.Element => {
    const { attached } = props;

    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const step = useBnbSelector(({ navigation }) => navigation.step);
    const settings = useBnbSelector((state) => state.commonSettings);
    const { showTradeIn, showInsurance } = useBnbSelector(enabledServicesSelector, shallowEqual);

    const [genericBasketDisclaimer, notAvailableOnlineLabel, genericDisclaimerTitle] = useBnbOptionalLabel([
        "genericBasketDisclaimer",
        "notAvailableOnlineBasketWarning",
        "genericDisclaimerTitle",
    ]);
    const showPrices = showPrice(settings);

    const onlinePurchaseNotPossible = useBnbSelector((state) => !isOnlinePurchaseAvailable(state.basket));

    return (
        <>
            <Styles.Wrapper attached={attached && showPrices} className="build-basket-wrapper">
                <Styles.Inner>
                    <Styles.BasketHeaderWrapper hideOnMobile={step === NavStep.Summary}>
                        <BasketHeader />
                    </Styles.BasketHeaderWrapper>

                    {step !== NavStep.Summary && <BasketItems showVehiclePrice />}
                    {step !== NavStep.Summary && <BasketServices />}
                    {showPrices && <ExternalPriceTaxDisclaimer />}
                    {showTradeIn && <TradeInDetails />}
                    <BasketMassManagement />

                    {showPrices && (
                        <Styles.PaymentDetailsWrapper>
                            {!!genericBasketDisclaimer && (
                                <Button.Link
                                    type="button"
                                    hasIconRight
                                    onClick={() =>
                                        dispatch(showModal({ type: MODAL_CONTENT, content: genericBasketDisclaimer }))
                                    }
                                >
                                    {genericDisclaimerTitle && <Text.Button>{genericDisclaimerTitle}</Text.Button>}
                                    <IconWrapper>
                                        <Icon variant="info" />
                                    </IconWrapper>
                                </Button.Link>
                            )}
                            <PaymentDetails />
                        </Styles.PaymentDetailsWrapper>
                    )}

                    {step === NavStep.Summary && <BasketETA />}

                    {/* Granularity */}
                    {onlinePurchaseNotPossible && notAvailableOnlineLabel && (
                        <Message.Info>
                            <IconWrapper>
                                <IconCart />
                            </IconWrapper>
                            {notAvailableOnlineLabel}
                        </Message.Info>
                    )}

                    {showInsurance && <InsuranceDetails />}

                    <Styles.DisclaimerWrapper>
                        <TotalPriceDisclaimers />
                    </Styles.DisclaimerWrapper>
                </Styles.Inner>
            </Styles.Wrapper>
        </>
    );
};

export default Basket;
